import { formatLocation } from "./formatLocation";

/**
 * Fetches the locations from the given Postal Location API `url` and formats them for use in `DhlDropdown` component.
 * You can choose to fetch only frequent locations by setting `onlyFrequent` to `true`.
 *
 * @param {{url: string, onlyFrequent?: boolean}} props
 * @returns {Promise<{label: string, value: string}[]>}
 */
export async function fetchLocations({ url, onlyFrequent = false }) {
  const response = await fetch(url);
  const {
    postalLocationList,
    frequentPostalLocationList,
  } = await response.json();

  return [
    ...frequentPostalLocationList,
    ...(onlyFrequent ? [] : postalLocationList),
  ].map(formatLocation);
}
